/**
 * Block deprecation
 *
 * @see https://developer.wordpress.org/block-editor/reference-guides/block-api/block-deprecation/
 * @see https://developer.wordpress.org/news/2023/03/block-deprecation-a-tutorial/
 */

import { useBlockProps, useInnerBlocksProps } from '@wordpress/block-editor';
import { filterOutWhiteSpace } from '../utils/general-utils';

const v1 = {
  supports: {
    anchor: true,
    html: false
  },
  attributes: {
    layout: {
      default: '50-50',
      type: 'string'
    },
    borderColor: {
      default: '',
      type: 'string'
    },
    textWithButtonBackgroundColor: {
      default: '',
      type: 'string'
    }
  },
  save({ attributes }) {
    const {
      layout,
      borderColor,
      textWithButtonBackgroundColor
    } = attributes;

    const blockProps = useBlockProps.save({
      className: 'block__image-with-text'
    });

    const is5050 = layout === '50-50' ? 'is-50-50' : '';
    const is6040 = layout === '40-60' ? 'is-40-60' : '';
    const isLayered = layout === 'layered' ? 'is-layered' : '';

    const layoutClasses = filterOutWhiteSpace( [
      is5050,
      is6040,
      isLayered
    ] );

    const borderBottomColor = borderColor && layout !== 'layered' ? { borderBottomColor: borderColor } : undefined;
    const borderBottomWidth = borderColor && layout !== 'layered' ? { borderBottomWidth: '6px' } : undefined;

    const layeredBgColor = textWithButtonBackgroundColor && isLayered ? { backgroundColor: textWithButtonBackgroundColor } : undefined;
    const layeredBorderColor = borderColor && isLayered ? { color: borderColor } : undefined;

    const { children, ...innerBlocksProps } = useInnerBlocksProps.save({
      className: `inner-blocks-wrapper relative ${layoutClasses}`
    });

    return (
      <div { ...blockProps }>
        <div className={ `image-with-text--inner ${borderColor ? 'has-border' : ''}` } style={ { ...borderBottomColor, ...borderBottomWidth, ...layeredBgColor, ...layeredBorderColor } }>
          <div { ...innerBlocksProps }>
            { children }
          </div>
        </div>
      </div>
    );
  }
};

export default [ v1 ];
